<app-header></app-header>
<main class="pages">
    <!--Page_Hero-Section -->
    <section class="gradient-light">
        <div class="container pt-lg-5">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <!-- <nav aria-label="breadcrumb text-center">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a routerLink="">Home</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Education</li>
                        </ol>
                    </nav> -->
                    <h1 alt="school survey app" class="h1-title mt-3">Looking for a transparent solution for your Educational Institute?</h1>
                    <p class="sub-text mt-2">Our education surveys are made for teachers, students and parents, for identifying areas of improvement and work on rectifying them.</p>
                    <div class="mt-lg-5 mt-0">
                        <a title="" class="btn btn-lg btn-success px-4 text-uppercase  mr-lg-2" data-toggle="modal" data-target="#callBack" id="callback">Request a Demo</a>
                    </div>
                </div>
                <div class="col-md-6 ">
                    <div class="page-banner-img">
                        <img class="img-fluid mt-lg-0 mt-3" alt="education survey" title="" src="assets/education.svg">
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- BOX Middle Section -->
    <section class="mb-5 pb-5">
        <div class="container">
            <div class="col-md-12">
                <div class="featured video card border-0 shadow mt-lg-5">
                    <div class="card-body">
                        <h2 alt="education survey app" class="h2-title text-center headings mb-4">Education</h2>
                        <p class="text-center sub-text">CViewSurvey app’s Education Survey permits you to gather feedback and opinions from students, parents, and educators. The real time data provided along with reports helps the individual as well as the Institute make informed decisions
                            and grab improvement opportunities, to always stay on the path of growth.</p>
                    </div>
                </div>
                <!-- play-video -->
                <div class="play-video">
                    <a class="video-play-button" (click)="scroll(target)">
                        <span></span>
                    </a>
                </div>
            </div>
        </div>
    </section>



    <!-- Page_Content -->
    <section class="mt-lg-5 mb-lg-5  pt-lg-5 pb-lg-5">
        <div class="container mb-lg-5">
            <h3 alt="templates for education survey" class="text-center">CView Education Surveys provide valuable insights into areas like:</h3>
        </div>
        <div class="features-screenshot-right ">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="lazy-image-wrapper loaded">
                            <img class="img-fluid mb-lg-0 mb-3" alt="career survey for students" src="assets/student_feedback.svg">
                        </div>
                    </div>

                    <div class="col-md-6">
                        <h3 alt="templates for education survey" class="feature-heading">STUDENT FEEDBACK</h3>
                        <p class="sub-text text-justify">Knowing the views and opinions of students is vital in running a successful Educational institution. Gathering feedback from the students makes you recognize areas which needs to be refined and areas which are performing well.</p>
                        <h3 alt="templates for education survey" class="feature-heading mt-4">TEACHER FEEDBACK</h3>
                        <p class="sub-text text-justify">Professors and Teachers form the backbone of the educational world. Making them feel heard and important increases the chances of retention and reduces turnover. Their constructive feedback gives useful insights that can be moulded
                            correctly for growth.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="features-screenshot-left">
            <div class="container">
                <div class="row align-items-center mob-column-reverse">
                    <div class="col-md-5">
                        <h3 alt="templates for education survey" class="feature-heading">PARENT FEEDBACK</h3>
                        <p class="sub-text text-justify">Gathering feedback from parents gives you their perspective about your Educational Institution.Parent feedback surveys help build a healthy relationship with parents that further strengthens the relationship with the child as well.</p>
                        <h5 class="feature-heading mt-4">COURSE FEEDBACK</h5>
                        <p class="sub-text text-justify">Course feedback is essential for the academic growth of the institution. This helps you know about how well the students are grasping the course, how is that benefiting them and how well are the educators able to teach. </p>
                    </div>
                    <div class="col-md-7">
                        <div class="lazy-image-wrapper loaded">
                            <img class="w-100 float-lg-right img-fluid mb-lg-0 mb-3" src="assets/parents-feedback.svg" alt="school survey questionnaire" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="features-screenshot-right ">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="lazy-image-wrapper loaded">
                            <img class="img-fluid w-100 float-lg-left mb-lg-0 mb-3" src="assets/teachers-satistfaction.svg" alt="teacher satisfaction survey">
                        </div>
                    </div>

                    <div class="col-md-6">
                        <h3 alt="templates for education survey" class="feature-heading">TEACHER’S EVALUATION</h3>
                        <p class="sub-text text-justify">Evaluating educators makes you understand about their efficiency. Knowing about the teaching methods the teachers employ can help you identify and reward great teachers and also recognize those who need help so that they can get
                            the required training to improve their efficiency.</p>
                        <h5 class="feature-heading mt-4">ADMINISTRATION EVALUATION</h5>
                        <p class="sub-text text-justify">The satisfaction of administration is equally important for a peaceful and successful teaching environment.Time to time evaluation of staff and teachers can help pick areas of development and areas that need refinement if any,
                            along with areas that are performing well and should be boosted.</p>
                    </div>
                </div>
            </div>
        </div>


        <div class="container my-5 d-none">
            <p class="text-center">
                CView Educational survey is a platform that captures a broad range of information, provides quick results, and offer privacy in responses.
            </p>
        </div>
    </section>

    <!-- Page_Video-Section -->
    <section #target class="bg-primary py-lg-5 mt-lg-5 position-relative">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="solution-video">
                        <!-- <video class="embed-responsive embed-responsive-16by9" autoplay [muted]="'muted'" controls loop>
                            <source class="embed-responsive-item" src="assets/video/how-cview-works.mp4"
                                type="video/mp4">
                            Your browser does not support the video tag.
                        </video> -->
                        <iframe width="580" height="335" [src]="safeURL" frameborder="0" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    </section>

</main>
<app-footer></app-footer>